import type {AppStorage} from '../index'

export class Secure {
  constructor(_storage: AppStorage) {}

  createUserSecure = () => {
    // if (this.storage.token) return this.storage.token
    // const authType = this.storage.authType ?? 1
    // const hashed = md5(this.secure())
    // return `${hashed}:${authType}`
    return ''
  }

  createChatSecure = () => {
    // const authType = this.storage.authType!
    // const hashed = md5(this.secure())
    // let modify = md5(`${hashed}aaa`)
    //
    // return `${modify}:${authType}`
    return ''
  }

  secure = () => {
    // const authType = this.storage.authType
    // const hash = this.storage.userHash
    //
    // if (!authType || !hash)
    //   return `${hash ?? ''}&${authType ?? 1}-923&754299&k90ASmdiwWWcls.s`
    //
    // switch (authType) {
    //   case AuthType.email:
    //     const email = this.storage.email!
    //     const password = this.storage.password!
    //     return `${hash}&${email}-${password}923&754299&k90ASmdiwWWcls.s`
    //   case AuthType.phone:
    //     const phone = this.storage.phone!
    //     const phonePromo = this.storage.promo!
    //     return `${hash}&${phone}-${phonePromo}923&754299&k90ASmdiwWWcls.s`
    //   default:
    //     const socialId = this.storage.socialId!
    //     const promo = this.storage.promo!
    //     return `${hash}&${socialId}-${promo}923&754299&k90ASmdiwWWcls.s`
    // }
    return ''
  }
}
